import {HrStatusEnum} from '@/services/api-clients';

export function driverHrTagColorFilter(tag: HrStatusEnum): string[] {
  switch(tag) {
    case HrStatusEnum.Reported: return ['', ''];
    case HrStatusEnum.Active: return ['', ''];
    case HrStatusEnum.HadPayout: return ['', ''];
    case HrStatusEnum.ToBeReported: return ['', ''];
    case HrStatusEnum.ToBeRemoved: return ['', ''];
    case HrStatusEnum.Removed: return ['', ''];
    case HrStatusEnum.MissingData: return ['', ''];
    case HrStatusEnum.Other: return ['', ''];
    case HrStatusEnum.StudentCardRequired: return ['', ''];
    case HrStatusEnum.StudentCardUploaded: return ['', ''];
    case HrStatusEnum.Bailiff: return ['', ''];
    case HrStatusEnum.B2B: return ['', ''];
    case HrStatusEnum.WithoutPayout: return ['', ''];
    case HrStatusEnum.ActivePayoutCurrentMonth: return ['', ''];
    case HrStatusEnum.ActivePayoutPreviousMonth: return ['', ''];
    case HrStatusEnum.MissingTaxOffice: return ['', ''];
    case HrStatusEnum.MissingCurrentInsurance: return ['', ''];
    case HrStatusEnum.MissingAnnuitantCard: return ['', ''];
    case HrStatusEnum.MissingDisabilityCertificate: return ['', ''];
    case HrStatusEnum.MissingInsuranceFromDuty: return ['', ''];
    case HrStatusEnum.MissingPensionerCard: return ['', ''];
    case HrStatusEnum.MissingPesel: return ['', ''];
    case HrStatusEnum.Resignation: return ['', ''];
    case HrStatusEnum.UnvalidatedContractOfMandate: return ['warning', 'warning--text'];
    case HrStatusEnum.ValidatedContractOfMandate: return ['success', 'success--text'];
    case HrStatusEnum.UnvalidatedStudentStatus: return ['warning', 'warning--text'];
    case HrStatusEnum.ValidatedStudentStatus: return ['success', 'success--text'];
    case HrStatusEnum.TaxSituation: return ['', ''];
    case HrStatusEnum.SiiRequest: return ['', ''];
    case HrStatusEnum.SiiResignationRequest: return ['', ''];
    case HrStatusEnum.MissingDriverLicenseNumber: return ['', ''];
    case HrStatusEnum.ToBeVerifiedInCepik: return ['', ''];
    case HrStatusEnum.VerifiedInCepik: return ['', ''];
    case HrStatusEnum.VerificationRejectedInCepik: return ['', ''];
    case HrStatusEnum.RentOnly: return ['', ''];
    case HrStatusEnum.WorkPermitRequired: return ['warning', 'warning--text'];
    case HrStatusEnum.ContractOfMandateOtherEmployerToVerify: return ['warning', 'warning--text'];
    case HrStatusEnum.InsuredByOtherPayer: return ['', ''];
  }
}
